import { buildIceHockeyLiveMobileProps } from "../buildIceHockeyLiveMobileProps";
import { getBackgroundImage } from "../../helpers";
export const buildIceHockeyLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildIceHockeyLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildIceHockeyLiveDesktopProps.js.map